import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const digestsNotificationsPersonalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings-digests',
	path: '/jira/settings/personal/digests',
};
